export const PREFIXES = {
    BUILTIN: 'builtin_',
    COLUMN: 'column_'
} as const;

export type BuiltinValue = 'none' | 'count';
export type PrefixedBuiltinValue = `${typeof PREFIXES.BUILTIN}${BuiltinValue}`;

export const VALUES = {
    NONE: `${PREFIXES.BUILTIN}none`,
    COUNT: `${PREFIXES.BUILTIN}count`
} as const;

export const valuePrefix = {
    addPrefix: {
        builtin: (value: string) => `${PREFIXES.BUILTIN}${value}`,
        column: (value: string) => `${PREFIXES.COLUMN}${value}`
    },
    removePrefix: (value: string) => {
        if (value.startsWith(PREFIXES.BUILTIN)) {
            return value.substring(PREFIXES.BUILTIN.length);
        }
        if (value.startsWith(PREFIXES.COLUMN)) {
            return value.substring(PREFIXES.COLUMN.length);
        }
        return value;
    },
    hasPrefix: {
        builtin: (value: string) => value.startsWith(PREFIXES.BUILTIN),
        column: (value: string) => value.startsWith(PREFIXES.COLUMN)
    },
    PREFIXES,
    VALUES
};
